import { useState, useEffect } from 'react';
import { getKYCProfile } from '../services/kyc';

export function useKYCProfile(account) {
    const [status, setStatus] = useState()
    const [fetching, setFetching] = useState(false)
    const [fetched, setFetched] = useState(false)

    useEffect(() => {
        const controller = new AbortController();
        const { signal } = controller;
        
        if(account && !fetching && !fetched) {
            setStatus()
            setFetching(true)
            getKYCProfile(account, ["blockpass"], signal)
                .then(data => {
                    setStatus(data)
                })
                .catch(e => {
                    console.error(e)
                    setStatus()
                })
                .finally(() => {
                    setFetching(false)
                    setFetched(true)
                })
        }

        // return () => controller.abort()
    }, [account])


    return { status, fetching, fetched };
}